import React from 'react';
import PageTemplate from '../components/PageTemplate';

/**
 * Page À propos
 * Utilise le composant PageTemplate pour afficher le contenu de la page 'about'
 */
const About = () => {
  return <PageTemplate slug="about" />;
};

export default About;
